export function todayLocal(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function normalizeSoldOutNight(value: string): string {
  const cleaned = value.trim().slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(cleaned)) {
    return cleaned;
  }
  const parts = cleaned.split(".");
  if (parts.length === 3) {
    const [day, month, year] = parts;
    if (!day || !month || !year) return cleaned;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
  return cleaned;
}

export function normalizeSoldOutNights(values: string[]): string[] {
  const seen = new Set<string>();
  const normalized: string[] = [];
  for (const value of values) {
    const iso = normalizeSoldOutNight(value);
    if (!iso || seen.has(iso)) continue;
    seen.add(iso);
    normalized.push(iso);
  }
  return normalized.sort();
}

export function splitSoldOutNightsByToday(
  nights: string[],
  todayIso: string = todayLocal(),
): { pastNights: string[]; futureNights: string[] } {
  const normalized = normalizeSoldOutNights(nights);
  return {
    pastNights: normalized.filter((iso) => iso < todayIso),
    futureNights: normalized.filter((iso) => iso >= todayIso),
  };
}

export function formatSoldOutNightGerman(iso: string): string {
  return normalizeSoldOutNight(iso).split("-").reverse().join(".");
}
